var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidepanelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 9,
    height: 18,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    fillOpacity: 0.05,
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3,
    width: 6,
    height: 18,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "currentColor",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidepanelIcon);
export default __webpack_public_path__ + "static/media/sidepanel-icon.7637bcbc0ce448cce11b194c3a3c3d58.svg";
export { ForwardRef as ReactComponent };